import React from 'react';
import { HiChevronRight } from 'react-icons/hi2';
import { Breadcrumb } from '../../../types/storage';

interface BreadcrumbNavProps {
  breadcrumbs: Breadcrumb[];
  onNavigate: (directoryId: number | null) => void;
}

export default function BreadcrumbNav({ breadcrumbs, onNavigate }: BreadcrumbNavProps): JSX.Element {
  return (
    <nav className="flex items-center space-x-2 text-sm">
      {breadcrumbs.map((crumb, index) => (
        <React.Fragment key={crumb.id ?? 'root'}>
          {index > 0 && (
            <HiChevronRight className="w-4 h-4 text-gray-400" />
          )}
          <button
            type="button"
            onClick={() => onNavigate(crumb.id)}
            className={`px-3 py-1.5 rounded-lg transition-all ${
              index === breadcrumbs.length - 1
                ? 'font-semibold text-primary-900 bg-secondary-200 cursor-default'
                : 'text-gray-600 hover:text-primary-900 hover:bg-secondary-200'
            }`}
            disabled={index === breadcrumbs.length - 1}
          >
            {crumb.name}
          </button>
        </React.Fragment>
      ))}
    </nav>
  );
}
